import i18n from '@plugins/i18n';

import { Collection, Exchange } from '@/models';

export class ExchangeCollection extends Collection {
    static type = 'ExchangeCollection';
    static endpoint = Exchange.api.index;
    static model = Exchange;

    get headers() {
        return [
            this.createHeader('id', i18n.t('id'), {
                classList: ['no-wrap'],
                width: '20rem'
            }),
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('control', '', {
                format: 'control',
                width: '7rem',
                persistent: true
            })
        ];
    }
}

export default ExchangeCollection;
